export function formatSellerReportDate(value: string): string {
  const parsed = new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00+02:00` : value);
  if (Number.isNaN(parsed.getTime())) return value;
  return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Africa/Johannesburg' }).format(parsed).replace(/\bSept\b/u, 'Sep');
}

export function formatSellerReportDateTime(value: string): string {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  const day = formatSellerReportDate(parsed.toISOString());
  const time = new Intl.DateTimeFormat('en-ZA', { hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone: 'Africa/Johannesburg' }).format(parsed);
  return `${day} at ${time}`;
}

export function formatSellerReportPeriod(from: string, to: string): string {
  return `${formatSellerReportDate(from)} – ${formatSellerReportDate(to)}`;
}

export function formatSellerReportMoney(value: string | null | undefined): string {
  if (!value) return 'Price not set';
  const amount = Number(value);
  return Number.isFinite(amount) ? new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR', maximumFractionDigits: 0 }).format(amount) : value;
}

export function sellerReportWindowCount(trend: Array<{ date: string; count: number }>, periodEnd: string, days: 7 | 30): number {
  const [year, month, day] = periodEnd.split('-').map(Number);
  if (!year || !month || !day) return 0;
  const firstDay = new Date(Date.UTC(year, month - 1, day - days + 1)).toISOString().slice(0, 10);
  return trend.reduce((total, point) => point.date >= firstDay && point.date <= periodEnd ? total + point.count : total, 0);
}